import React from 'react'
import {
    Grid, Typography, List,
    ListItem,
    ListItemText,
    Button,
    IconButton,
    ListItemSecondaryAction,
    Divider,
    withStyles
} from '@material-ui/core'
import EditOutlinedIcon from '@material-ui/icons/EditOutlined';
import DeleteOutlinedIcon from '@material-ui/icons/DeleteOutlined';

import { customAddress } from '../../../utils';

const style = ((theme) => ({
    listWrapper: {
        width: "100%",
        display: "flex"
    },
    addIdButtonText: {
        color: theme.palette.ternary.main,
        fontWeight: 600
    },
    gutter: {
        padding: "16px 16px"
    },
    gutterTop: {
        padding: "16px 16px 0px"
    },
    gutterMiddle: {
        padding: "0px 16px"
    },
    gutterBottom: {
        padding: "0px 16px 16px"
    },
    listItemSecondaryAction: {
        paddingRight: 90
    }
}))

class ViewAllCards extends React.Component {

    state={
        address: []
    }

    componentDidMount() {
        this.setState({
            address: [...this.props.items]
        })
    }


    callBackOnSaveAddress = (data, isremove) => {
        if (isremove) {
          let isUpdateData = this.state.address?.filter(
            (val) => val.value !== data?.value
          );
  
          this.setState({ address: isUpdateData }, () => {
            this.props.onRemove(data, true)
          });
        } 
      };

    render() {
        const { classes } = this.props
        const { address } = this.state
        const { onAdd, onEdit } = this.props
        return (
            <div>
                <Grid container>
                    <Grid item container xs={12} className={classes.gutter}>
                        <Grid item xs={6}>
                            <Typography variant={"h6"}>Address</Typography>
                        </Grid>
                        <Grid item xs={6} style={{ display: 'flex', justifyContent: "flex-end" }}>
                            <Button style={{boxShadow: "none"}}>
                                <Typography id={this.props?.id?.add_drawer_address_id} onClick={onAdd} variant={"body2"} className={classes.addIdButtonText}>+ ADD ADDRESS</Typography>
                            </Button>
                        </Grid>
                    </Grid>

                    <Grid item xs={12}>
                        <Divider light />
                    </Grid>

                    {address?.map(item => {
                        return (
                            <Grid item xs={12}>
                                <div className={classes.listWrapper}>
                                    <List dense={true} style={{ width: "100%" }} >
                                        <ListItem divider classes={{ secondaryAction: classes.listItemSecondaryAction}}>
                                            <ListItemText
                                                primary={item?.label ? item?.label : null}
                                                secondary={customAddress(
                                                    item?.addressLine1,
                                                    item?.addressLine2,
                                                    item?.area,
                                                    item?.state,
                                                    item?.country,
                                                    item?.postalCode
                                                )}
                                            />
                                            <ListItemSecondaryAction>
                                                <div style={{ display: "flex", gap: 16 }}>
                                                    <IconButton id={this.props?.id?.edit_drawer_address_icon_id} onClick={() => onEdit(item)} edge="end" aria-label="edit" size={"small"}>
                                                        <EditOutlinedIcon fontSize={"small"} />
                                                    </IconButton>
                                                    <IconButton id={this.props?.id?.delete_drawer_address_icon_id} onClick={() => {this.callBackOnSaveAddress(item, true)}} edge="end" aria-label="delete" size={"small"}>
                                                        <DeleteOutlinedIcon fontSize={"small"} />
                                                    </IconButton>
                                                </div>
                                            </ListItemSecondaryAction>
                                        </ListItem>
                                    </List>
                                </div>
                            </Grid>
                        )
                    })}
                </Grid>
            </div>
        )
    }
}

export default withStyles(style)(ViewAllCards)
